// Full-bleed hero photo. The 2026-05-25 audit
// (.notes/design-grades/customer/01-home.md #1) called the right band of
// the hero gradient "the single best billboard slot"; we now fill the
// whole hero with a real equipment photo (free CC0/Pexels-licensed; see
// db/seeds/inventory_photos/SOURCES.md).
//
// A left→right flag-navy gradient (heavier on the left, where the headline
// and CTAs live) plus a bottom-up navy fade keep the copy legible while the
// machine reads clearly on the right. All colour flows through Tailwind
// tokens, so the no_hardcoded_hex_in_customer architecture spec stays
// satisfied.
//
// `aria-hidden` because it's purely decorative; the headline + CTAs carry
// the message for assistive tech.
import heroEquipment from "./hero-equipment.jpg";

export function HeroEquipmentArt(): JSX.Element {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 overflow-hidden"
      data-testid="hero-equipment-art"
    >
      <img
        src={heroEquipment}
        alt=""
        className="h-full w-full object-cover object-center"
      />
      {/* Heavier navy on the left keeps the headline + CTAs legible; eases
          toward the right where the machine sits. */}
      <div className="absolute inset-0 bg-gradient-to-r from-flag-navy via-flag-navy/80 to-flag-navy/40" />
      {/* Bottom-up navy fade grounds the photo into the section. */}
      <div className="absolute inset-0 bg-gradient-to-t from-flag-navy/70 to-transparent" />
      {/* Brand-red base line — keeps the jobsite ground-line motif. */}
      <div className="absolute inset-x-0 bottom-0 h-1 bg-brand-red/70" />
    </div>
  );
}
